import { lifeMapDefaultConfig, lifeMapPlugin } from './lifeMap'
import { familyTreeDefaultConfig, familyTreePlugin } from './familyTree'

export const graphTypePlugins = {
  lifeMap: lifeMapPlugin,
  familyTree: familyTreePlugin
}

export const graphTypeDefaultConfigs = {
  lifeMap: lifeMapDefaultConfig,
  familyTree: familyTreeDefaultConfig
}

export function getGraphTypePlugin (graphType) {
  return graphTypePlugins[graphType] || null
}

export function getGraphTypeDefaultConfig (graphType) {
  return graphTypeDefaultConfigs[graphType] || {}
}
